import React from 'react';
import { useWeb3React } from '@web3-react/core';
import {Contract} from "@ethersproject/contracts";

import {abi as TokenAbi} from "./contracts/StandartToken.json";
import {abi as GovernanceTokenAbi} from "./contracts/GovernanceToken.json";
import {abi as StakingAbi} from "./contracts/Staking.json";
import {abi as GovernorAbi} from "./contracts/GovernorAlpha.json";

const EthereumContext = React.createContext({});

function EthereumProvider({children}) {
    const { account, library } = useWeb3React();
    const [contextValue, setContextValue] = React.useState({});

    const initialize = async (account) => {
        console.log("Initializing Ethereum Provider for", account);
        const provider = library;

        if(!provider) {
            return;
        }

        const roobee = new Contract(
            process.env.REACT_APP_ROOBEE_ADDRESS,
            TokenAbi,
            account ? provider.getSigner(0) : provider
        );
        const xRoobee = new Contract(
            process.env.REACT_APP_GOV_ROOBEE_ADDRESS,
            GovernanceTokenAbi,
            account ? provider.getSigner(0) : provider
        );
        const staking = new Contract(
            process.env.REACT_APP_STAKING_ADDRESS,
            StakingAbi,
            account ? provider.getSigner(0) : provider
        );
        const governor = new Contract(
            process.env.REACT_APP_GOVERNOR_ADDRESS,
            GovernorAbi,
            account ? provider.getSigner(0) : provider
        );
        setContextValue({provider, roobee, xRoobee, governor, staking, account, validNetwork: true});
    }

    console.log(library);

    React.useEffect(() => {
        initialize(account);
    }, [account]);

    React.useEffect(() => {
        if (!!library) {

            library.on('accountsChanged', ([newAccount]) => {
                console.log("Changed account");
                initialize(newAccount).then();
            });

            library.on('chainChanged', () => window.location.reload());
        }
    }, [library]);

    return (
        <EthereumContext.Provider value={contextValue}>
            {children}
        </EthereumContext.Provider>
    )
}

function useEthereum() {
    return React.useContext(EthereumContext);
}

export {EthereumProvider, useEthereum};